module.exports = __webpack_public_path__ + "img/churujing.6b6f86f1.png";